import React from 'react'

import cx from 'classnames'

import Arrow from './Arrow'

import styles from './styles.module.css'

export enum TrendDirection {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  // unused (so far)
  SIDEWAYS = 'sideways',
  NONE = 'none',
}

interface IProps extends React.ComponentPropsWithoutRef<'div'> {
  direction: TrendDirection
}

const TrendIndicator: React.FC<IProps> = ({
  direction,
  className,
  children,
  ...rest
}) => (
  <span
    className={cx(styles.trendIndicator, styles[direction], className)}
    {...rest}
  >
    <Arrow />
    {!!children && <span>{children}</span>}
  </span>
)

export default TrendIndicator
